import { devtools, persist } from 'zustand/middleware';

import { type WalletConnectingData } from '@pkg/types';

import { create } from '@app/store/zustand/helpers/create';

export interface WalletStoreData {
    showOverview: boolean;
    disconnectingAddress?: string;
    connecting?: WalletConnectingData;
}

export interface WalletStoreState extends WalletStoreData {
    toggleShowOverview: (show?: boolean) => void;
    setConnecting: (data?: WalletConnectingData) => void;
    setDisconnectingAddress: (disconnectingAddress?: string, closeOnDisconnect?: boolean) => void;
    reset: () => void;
}

const initialState: WalletStoreData = {
    showOverview: false,
    connecting: undefined,
    disconnectingAddress: undefined,
};

export const STORE_KEY_WALLET = 'wallet-store-v2';

export const useWalletStore = create<WalletStoreState>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setDisconnectingAddress: (disconnectingAddress) => set({ disconnectingAddress }),
                toggleShowOverview: (show) =>
                    set((state) => ({
                        showOverview: show ?? !state.showOverview,
                    })),
                setConnecting: (data) => set({ connecting: data }),
                reset: () => set(initialState),
            }),
            { name: STORE_KEY_WALLET },
        ),
    ),
);

export function handleClearWalletStore() {
    return useWalletStore.getState().reset();
}
